/*
 * Marketim base behaviour (foundation agent).
 * - Desktop: open mega menus / dropdowns on hover (Dawn's click + keyboard
 *   behaviour from details-disclosure.js stays untouched).
 * - Header cart total refresh after Ajax cart updates.
 * Vanilla JS, no dependencies.
 */
(function () {
  'use strict';

  var HOVER_OPEN_DELAY = 80;
  var HOVER_CLOSE_DELAY = 180;

  function canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)').matches;
  }

  function bindHoverMenu(menu) {
    if (menu.dataset.mkHover === 'true') return;
    menu.dataset.mkHover = 'true';

    var details = menu.querySelector('details');
    if (!details) return;
    var summary = details.querySelector('summary');
    var openTimer;
    var closeTimer;

    menu.addEventListener('mouseenter', function () {
      if (!canHover()) return;
      window.clearTimeout(closeTimer);
      openTimer = window.setTimeout(function () {
        if (details.open) return;
        // close sibling menus first so only one panel is open at a time
        document.querySelectorAll('.mk-nav header-menu').forEach(function (other) {
          if (other !== menu && typeof other.close === 'function') other.close();
        });
        details.setAttribute('open', '');
        if (summary) summary.setAttribute('aria-expanded', 'true');
      }, HOVER_OPEN_DELAY);
    });

    // A mouse click on an already hover-opened item should not toggle it shut.
    // Keyboard activation (event.detail === 0) keeps Dawn's normal toggle.
    if (summary) {
      summary.addEventListener('click', function (event) {
        if (!canHover() || event.detail === 0) return;
        event.preventDefault();
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });
    }

    menu.addEventListener('mouseleave', function () {
      if (!canHover()) return;
      window.clearTimeout(openTimer);
      closeTimer = window.setTimeout(function () {
        // keep it open while keyboard focus is inside
        if (menu.contains(document.activeElement) && document.activeElement !== document.body) {
          var focused = document.activeElement;
          if (focused.matches && focused.matches(':focus-visible')) return;
        }
        if (typeof menu.close === 'function') menu.close();
      }, HOVER_CLOSE_DELAY);
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.mk-nav header-menu').forEach(bindHoverMenu);
  }

  /* Header cart: keep the total in sync after Ajax cart updates and make the
     whole labeled cart link open the cart drawer (Dawn binds only #cart-icon-bubble). */
  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: currency,
        currencyDisplay: 'narrowSymbol',
      }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  }

  function refreshCartTotal() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        document.querySelectorAll('[data-mk-cart-total]').forEach(function (el) {
          el.textContent = formatMoney(cart.total_price, cart.currency);
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function initCart() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCartTotal);
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest && event.target.closest('.mk-action--cart');
      if (!link || !document.querySelector('cart-drawer')) return;
      var bubble = document.getElementById('cart-icon-bubble');
      if (!bubble || bubble.contains(event.target)) return;
      event.preventDefault();
      bubble.click();
    });
  }

  init();
  initCart();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
